/* eslint-disable no-unused-vars */
import { useState, useCallback, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { FiX, FiChevronLeft } from "react-icons/fi";
import { useDropzone } from "react-dropzone";

const UploadAndCropImageModal = ({
	show,
	handleImageCropped,
	handleClose,
	aspect = true,
}) => {
	const [crop, setCrop] = useState({
		aspect: aspect ? 1 : null,
		x: 0,
		y: 0,
		width: 50,
		height: 50,
	});
	const [image, setImage] = useState(null);
	const [file, setFile] = useState(null);
	const [originalFile, setOriginalFile] = useState(null);
	const [croppedImage, setCroppedImage] = useState(null);

	const onDrop = useCallback((acceptedFiles) => {
		const reader = new FileReader();
		reader.readAsDataURL(acceptedFiles[0]);
		setOriginalFile(acceptedFiles[0]);
		reader.onload = (e) => {
			setFile(e.target.result);
		};
	}, []);

	const { getRootProps, getInputProps } = useDropzone({
		accept: {
			"image/*": [],
		},
		onDrop,
	});

	const getCroppedImage = () => {
		const canvas = document.createElement("canvas");
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = crop.width;
		canvas.height = crop.height;
		const ctx = canvas.getContext("2d");

		const pixelRatio = window.devicePixelRatio;
		canvas.width = crop.width * pixelRatio;
		canvas.height = crop.height * pixelRatio;
		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
		ctx.imageSmoothingQuality = "high";

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width,
			crop.height
		);

		let extension = file?.split(";")[0].split(":")[1] || "image/png";
		if (extension.includes("svg")) {
			extension = "image/png";
		}

		// Converting to base64

		const base64Image = canvas.toDataURL(extension);
		if (base64Image.toString().includes(`data:${extension};base64`)) {
			setCroppedImage(base64Image);
		}
	};

	const handleCloseModal = () => {
		handleClose();
		setImage(null);
		setFile(null);
		setCroppedImage(null);
		setCrop({ aspect: 1, x: 0, y: 0, height: 50, width: 50 });
	};

	const handleUpload = () => {
		handleImageCropped(croppedImage);
		handleCloseModal();
	};

	return (
		<div className="modal-view">
			<Modal show={show} size="lg">
				<Modal.Header className="spaceBetween">
					{croppedImage ? (
						<FiChevronLeft
							size={30}
							title="Crop again"
							className="cursor-pointer"
							onClick={() => setCroppedImage(null)}
						/>
					) : (
						<span></span>
					)}
					<Modal.Title
						id="contained-modal-title-vcenter"
						className="main-title"
					>
						<span>Upload Image</span>
					</Modal.Title>
					<FiX
						size={30}
						title="Close"
						className="cursor-pointer"
						onClick={handleCloseModal}
					/>
				</Modal.Header>
				<Modal.Body>
					{croppedImage ? (
						<div className="center">
							<img src={croppedImage} alt="Cropped Image" />
						</div>
					) : file ? (
						<ReactCrop
							src={file}
							onImageLoaded={setImage}
							crop={crop}
							onChange={setCrop}
						/>
					) : (
						<div
							{...getRootProps()}
							className="image-container"
							onClick={() => document.getElementById("imageFile").click()}
						>
							<input
								multiple={false}
								id="imageFile"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onChange={(e) =>
									setFile(URL.createObjectURL(e.target.files[0]))
								}
								{...getInputProps()}
							/>
							Drop or select image
						</div>
					)}
				</Modal.Body>
				<Modal.Footer>
					{croppedImage ? (
						<Button className="btn-medium" onClick={handleUpload}>
							Upload
						</Button>
					) : file ? (
						<Button className="btn-medium" onClick={getCroppedImage}>
							Crop & Preview
						</Button>
					) : // <Button className="btn-medium" onClick={handleCloseModal}>
					// 	Cancel
					// </Button>
					null}
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default UploadAndCropImageModal;
